<div class="max-w-5xl mx-auto" (click)="closeActionsMenu()">
  <header>
    <div class="mx-auto mb-2 flex items-baseline gap-3 flex-wrap">
      <h1 class="text-3xl font-bold leading-tight tracking-tight" [ngClass]="{
        'text-gray-900': !isDarkMode(),
        'text-white': isDarkMode()
      }">Team</h1>
      <span class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold uppercase tracking-wide"
        [ngClass]="{
          'bg-amber-100 text-amber-800': isOwner && !isDarkMode(),
          'bg-amber-500/15 text-amber-400': isOwner && isDarkMode(),
          'bg-emerald-100 text-emerald-700': !isOwner && !isDarkMode(),
          'bg-emerald-500/15 text-emerald-400': !isOwner && isDarkMode()
        }">
        You're the {{ isOwner ? 'owner' : 'admin' }}
      </span>
    </div>
    <div class="mx-auto mb-10">
      <p class="text-sm" [ngClass]="{ 'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode() }">
        Invite teammates, hand out admin access, or update who can sign in.
      </p>
    </div>
  </header>

    <div class="-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap gap-3">
      <!-- search input -->
      <div class="ml-4 mt-4 w-2/4">
        <div>
          <div class=" flex rounded-md shadow-sm w-full">
            <div class="relative flex flex-grow items-stretch focus-within:z-10">
              <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="size-6 stroke-slate-400">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>


              </div>
              <input type="email" name="email" id="email" (change)="searchMember($event)"
                class="block w-full rounded-md border-0 py-2 pl-10 focus:ring-2 focus:ring-inset focus:ring-indigo-600 dark:focus:ring-blue-500 sm:text-sm sm:leading-6"
                [ngClass]="{
                  'text-gray-900 bg-white ring-gray-300 placeholder:text-gray-400': !isDarkMode(),
                  'text-white bg-gray-700 ring-gray-600 placeholder:text-gray-500': isDarkMode()
                }"
                placeholder="Search team members by name">
            </div>
          </div>
        </div>
      </div>

      <!-- button search -->
      <div class="mt-4 flex-shrink-0">
        <button type="button" (click)="openInviteModal()"
          class="relative inline-flex items-center rounded-md bg-emerald-500 px-3 py-2 text-sm font-base text-white shadow-sm hover:bg-emerald-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
            class="size-4 gap-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>
          Invite
        </button>
      </div>
    </div>

  <ul role="list"
    class="flex-col justify-center divide-y ring-1 mt-5 shadow-sm sm:rounded-xl max-w-7xl mx-auto min-h-16 text-center items-center"
    [ngClass]="{
      'divide-gray-100 bg-white ring-gray-900/5': !isDarkMode(),
      'divide-gray-700 bg-gray-800 ring-gray-700/50': isDarkMode()
    }">
    <li *ngFor="let member of members"  class="w-full relative flex justify-between gap-x-6 px-4 py-4 sm:px-6 text-left">
      <div class="flex min-w-0 gap-x-4">
        <div class="relative flex-none">
          <img *ngIf="member.image_url" class="h-11 w-11 rounded-full bg-gray-50"
            src="{{member.image_url}}"
            alt="">
          <div *ngIf="!member.image_url" class="h-11 w-11 flex rounded-full justify-center content-center items-center text-sm font-semibold"
            [ngClass]="{
              'bg-slate-100 text-gray-900': !isDarkMode(),
              'bg-gray-600 text-white': isDarkMode()
            }">{{member.name.substring(0,1)}}</div>
          <!-- Status dot: green = has activated their account, gray = invite pending -->
          <span class="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full ring-2"
            [title]="member.disabled ? 'Invitation pending' : 'Active'"
            [ngClass]="{
              'bg-emerald-500': !member.disabled,
              'bg-gray-300': member.disabled,
              'ring-white': !isDarkMode(),
              'ring-gray-800': isDarkMode()
            }"></span>
        </div>

        <div class="min-w-0 flex-auto items-center content-center">
          <p class="text-sm font-semibold leading-5 flex items-center gap-2 flex-wrap" [ngClass]="{
            'text-gray-900': !isDarkMode(),
            'text-white': isDarkMode()
          }">
            {{member.name}} <span *ngIf="member.job_title" class="font-normal" [ngClass]="{'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode()}">· {{member.job_title}}</span>
            <span *ngIf="isSelf(member)" class="text-xs font-normal" [ngClass]="{'text-gray-400': !isDarkMode(), 'text-gray-500': isDarkMode()}">(you)</span>

            <span class="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide"
              [ngClass]="{
                'bg-emerald-100 text-emerald-700': member.role === 'admin' && !isDarkMode(),
                'bg-emerald-500/15 text-emerald-400': member.role === 'admin' && isDarkMode(),
                'bg-slate-100 text-slate-500': member.role !== 'admin' && !isDarkMode(),
                'bg-gray-700 text-gray-300': member.role !== 'admin' && isDarkMode()
              }">
              {{ member.role === 'admin' ? 'Admin' : 'Member' }}
            </span>

            <span *ngIf="member.disabled" class="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium"
              [ngClass]="{
                'bg-amber-100 text-amber-700': !isDarkMode(),
                'bg-amber-500/15 text-amber-400': isDarkMode()
              }">
              Invite pending
            </span>
          </p>
          <p class="mt-1 flex text-xs leading-5" [ngClass]="{
            'text-gray-500': !isDarkMode(),
            'text-gray-400': isDarkMode()
          }">
            {{member.email}}
          </p>
        </div>
      </div>

      <!-- Actions menu -->
      <div class="flex shrink-0 items-center">
        <div class="relative">
          <button type="button" (click)="$event.stopPropagation(); toggleActionsMenu(member.id)"
            class="rounded-md p-2 hover:bg-opacity-80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            [ngClass]="{
              'text-gray-500 hover:bg-gray-100 focus-visible:outline-indigo-600': !isDarkMode(),
              'text-gray-400 hover:bg-gray-700 focus-visible:outline-blue-500': isDarkMode()
            }"
            aria-label="Member actions">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-5">
              <path d="M12 6.75a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM12 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM13.5 18.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
            </svg>
          </button>

          <div *ngIf="openActionsMenuId === member.id" (click)="$event.stopPropagation()"
            class="absolute right-0 z-20 mt-1 w-56 origin-top-right rounded-md shadow-lg ring-1 ring-black ring-opacity-5 py-1"
            [ngClass]="{ 'bg-white': !isDarkMode(), 'bg-gray-800 ring-gray-700': isDarkMode() }">

            <button type="button" (click)="openEditMemberModal(member.id); closeActionsMenu()"
              class="block w-full text-left px-4 py-2 text-sm"
              [ngClass]="{ 'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-200 hover:bg-gray-700': isDarkMode() }">
              Edit permissions
            </button>

            <button *ngIf="canActOnMember(member)" type="button" (click)="openChangeEmailModal(member)"
              class="block w-full text-left px-4 py-2 text-sm"
              [ngClass]="{ 'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-200 hover:bg-gray-700': isDarkMode() }">
              Change email
            </button>

            <button *ngIf="canActOnMember(member)" type="button" (click)="openChangePasswordModal(member); closeActionsMenu()"
              class="block w-full text-left px-4 py-2 text-sm"
              [ngClass]="{ 'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-200 hover:bg-gray-700': isDarkMode() }">
              Change password
            </button>

            <button *ngIf="member.disabled" type="button" (click)="resendInvite(member)" [disabled]="resendingInviteFor === member.id"
              class="block w-full text-left px-4 py-2 text-sm disabled:opacity-50"
              [ngClass]="{ 'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-200 hover:bg-gray-700': isDarkMode() }">
              {{ resendingInviteFor === member.id ? 'Sending...' : 'Resend invite' }}
            </button>

            <button *ngIf="member.can_use_advanced_editor" type="button" (click)="syncMemberClaims(member); closeActionsMenu()"
              class="block w-full text-left px-4 py-2 text-sm"
              [ngClass]="{ 'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-200 hover:bg-gray-700': isDarkMode() }">
              Sync permissions
            </button>

            <div class="my-1 border-t" [ngClass]="{ 'border-gray-100': !isDarkMode(), 'border-gray-700': isDarkMode() }" *ngIf="!isSelf(member) && canActOnMember(member)"></div>

            <button *ngIf="!isSelf(member) && canActOnMember(member) && member.role !== 'admin'" type="button" (click)="promoteToAdmin(member)"
              class="block w-full text-left px-4 py-2 text-sm font-medium text-emerald-600 hover:bg-emerald-50"
              [ngClass]="{ 'hover:bg-emerald-50': !isDarkMode(), 'hover:bg-emerald-500/10': isDarkMode() }">
              Promote to admin
            </button>

            <button *ngIf="!isSelf(member) && canActOnMember(member) && member.role === 'admin'" type="button" (click)="demoteToMember(member)"
              class="block w-full text-left px-4 py-2 text-sm"
              [ngClass]="{ 'text-gray-700 hover:bg-gray-50': !isDarkMode(), 'text-gray-200 hover:bg-gray-700': isDarkMode() }">
              Demote to member
            </button>

            <button *ngIf="!isSelf(member) && canActOnMember(member)" type="button" (click)="showNotificationForRemove(member.id, member.name); closeActionsMenu()"
              class="block w-full text-left px-4 py-2 text-sm font-medium text-red-600"
              [ngClass]="{ 'hover:bg-red-50': !isDarkMode(), 'hover:bg-red-500/10': isDarkMode() }">
              Remove from team
            </button>

            <p *ngIf="!isSelf(member) && !canActOnMember(member)" class="px-4 py-2 text-xs" [ngClass]="{ 'text-gray-400': !isDarkMode(), 'text-gray-500': isDarkMode() }">
              Only the owner can change another admin.
            </p>
          </div>
        </div>
      </div>
    </li>

    <div *ngIf="this.members.length==0" class="flex flex-col items-center justify-center gap-1 py-10 text-center"
      [ngClass]="{
        'text-gray-500': !isDarkMode(),
        'text-gray-400': isDarkMode()
      }">
      <p class="text-sm font-medium">No teammates yet</p>
      <p class="text-xs">Invite someone to help run this account.</p>
    </div>

  </ul>


  <!-- MODAL FOR NEW MEMBER-->
  <div *ngIf="showInviteModal" class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
    <div class="fixed inset-0 transition-opacity" aria-hidden="true"
      [ngClass]="{
        'bg-gray-500 bg-opacity-75': !isDarkMode(),
        'bg-gray-900 bg-opacity-80': isDarkMode()
      }"></div>

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
        <div
          class="relative transform overflow-hidden rounded-lg px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
          [ngClass]="{
            'bg-white': !isDarkMode(),
            'bg-gray-800': isDarkMode()
          }">
          <div>
            <div (click)="closeInviteModal()" class="absolute top-5 right-5 rounded-full cursor-pointer hover:bg-red-400 hover:text-white px-1 py-1 flex justify-center content-center"
              [ngClass]="{
                'bg-slate-100 text-gray-900': !isDarkMode(),
                'bg-gray-600 text-white': isDarkMode()
              }">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>

            </div>
            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-8">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
              </svg>

            </div>
            <div class="mt-3 text-left sm:mt-5">
              <h3 class="text-lg font-semibold text-center leading-6" id="modal-title"
                [ngClass]="{
                  'text-gray-900': !isDarkMode(),
                  'text-white': isDarkMode()
                }">Invite a new team
                member
              </h3>
              <!--
              This example requires some changes to your config:

              ```
              // tailwind.config.js
              module.exports = {
                // ...
                plugins: [
                  // ...
                  require('@tailwindcss/forms'),
                ],
              }
              ```
            -->
              <form class="isolate -space-y-px rounded-md shadow-sm mt-5">
                <legend class="mt-10 pb-4 text-base font-semibold flex gap-2 text-gray-900 dark:text-white">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z" />
                  </svg>

                  Profile
                </legend>
                <div
                  class="relative rounded-md rounded-b-none px-3 pb-1.5 pt-2.5 ring-1 ring-inset focus-within:z-10 focus-within:ring-2"
                  [ngClass]="{
                    'ring-gray-300 focus-within:ring-emerald-500 bg-white': !isDarkMode(),
                    'ring-gray-600 focus-within:ring-blue-500 bg-gray-800': isDarkMode()
                  }">
                  <label for="name" class="block text-sm font-medium"
                  [ngClass]="{
                    'text-gray-900': !isDarkMode(),
                    'text-gray-200': isDarkMode()
                  }">Email <span class="text-xs"
                      [ngClass]="{
                        'text-slate-400': !isDarkMode(),
                        'text-gray-500': isDarkMode()
                      }">(required)</span></label>
                  <input type="email" name="email" id="email"
                    class="block w-full border-0 p-0 py-2 bg-transparent focus:ring-0 sm:text-sm sm:leading-6"
                      [ngClass]="{
                        'text-gray-900 placeholder:text-gray-400': !isDarkMode(),
                        'text-white placeholder:text-gray-500': isDarkMode()
                      }"
                    placeholder="jane@acme.inc" [(ngModel)]="email">
                </div>

                <div class="flex ">
                  <div
                    class="relative px-3 pb-1.5 pt-2.5 border-r border-l ring-inset focus-within:z-10 focus-within:ring-2"
                    [ngClass]="{
                      'border-gray-300 ring-gray-300 focus-within:ring-emerald-500': !isDarkMode(),
                      'border-gray-600 ring-gray-600 focus-within:ring-blue-500': isDarkMode()
                    }">
                    <label for="name" class="block text-sm font-medium"
                  [ngClass]="{
                    'text-gray-900': !isDarkMode(),
                    'text-gray-200': isDarkMode()
                  }">Name <span class="text-xs"
                      [ngClass]="{
                        'text-slate-400': !isDarkMode(),
                        'text-gray-500': isDarkMode()
                      }">(required)</span></label>
                    <input type="text" name="fullname" id="fullname"
                      class="block w-full border-0 p-0 py-2 bg-transparent focus:ring-0 sm:text-sm sm:leading-6"
                      [ngClass]="{
                        'text-gray-900 placeholder:text-gray-400': !isDarkMode(),
                        'text-white placeholder:text-gray-500': isDarkMode()
                      }"
                      placeholder="Jane Smith" [(ngModel)]="name">
                  </div>
                  <div
                    class="relative rounded-md rounded-t-none px-3 pb-1.5 pt-2.5 border-r ring-inset focus-within:z-10 focus-within:ring-2"
                    [ngClass]="{
                      'border-gray-300 ring-gray-300 focus-within:ring-emerald-500': !isDarkMode(),
                      'border-gray-600 ring-gray-600 focus-within:ring-blue-500': isDarkMode()
                    }">
                    <label for="job-title" class="block text-sm font-medium"
                  [ngClass]="{
                    'text-gray-900': !isDarkMode(),
                    'text-gray-200': isDarkMode()
                  }">Job Title</label>
                    <input type="text" name="job-title" id="job-title"
                      class="block w-full border-0 p-0 py-2 bg-transparent focus:ring-0 sm:text-sm sm:leading-6"
                      [ngClass]="{
                        'text-gray-900 placeholder:text-gray-400': !isDarkMode(),
                        'text-white placeholder:text-gray-500': isDarkMode()
                      }"
                      placeholder="Head of ..." [(ngModel)]="job_title">
                  </div>
                </div>

                <!-- Role: a segmented control, not a checkbox -- this is the
                     one choice that decides everything else on this form. -->
                <div class="relative rounded-md rounded-t-none px-3 py-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">
                  <label class="block text-sm font-medium mb-2" [ngClass]="{ 'text-gray-900': !isDarkMode(), 'text-gray-200': isDarkMode() }">Role</label>
                  <div class="grid grid-cols-2 gap-2">
                    <button type="button" (click)="role = 'member'"
                      class="rounded-md px-3 py-2 text-sm font-medium border transition-colors"
                      [ngClass]="{
                        'bg-emerald-500 text-white border-emerald-500': role === 'member',
                        'bg-transparent border-gray-300 text-gray-600 hover:border-emerald-300': role !== 'member' && !isDarkMode(),
                        'bg-transparent border-gray-600 text-gray-300 hover:border-emerald-400': role !== 'member' && isDarkMode()
                      }">Member</button>
                    <button type="button" (click)="role = 'admin'"
                      class="rounded-md px-3 py-2 text-sm font-medium border transition-colors"
                      [ngClass]="{
                        'bg-emerald-500 text-white border-emerald-500': role === 'admin',
                        'bg-transparent border-gray-300 text-gray-600 hover:border-emerald-300': role !== 'admin' && !isDarkMode(),
                        'bg-transparent border-gray-600 text-gray-300 hover:border-emerald-400': role !== 'admin' && isDarkMode()
                      }">Admin</button>
                  </div>
                  <p *ngIf="role === 'admin'" class="mt-2 text-xs" [ngClass]="{ 'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode() }">
                    Admins get full access to every agent and setting in this account, just like you.
                  </p>
                </div>

                <ng-container *ngIf="role === 'member'">

                <div
                  class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">
                    <div class="flex items-center">
                      <!-- Enabled: "bg-indigo-600", Not Enabled: "bg-gray-200" -->
                      <button type="button" id="btn-can-edit" (click)="toggleCanEdit()" [class.bg-emerald-500]="can_edit" [class.bg-gray-200]="!can_edit"  class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                      [ngClass]="{
                        'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                        'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                      }" role="switch" aria-checked="false" aria-labelledby="can-edit-label">
                        <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
                        <span aria-hidden="true" [class.translate-x-5]="can_edit" [class.translate-x-0]="!can_edit" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                      </button>
                      <input type="hidden" id="can-edit" name="can-edit" value="false" [(ngModel)]="can_edit">
                      <span class="ml-3 text-sm" id="annual-billing-label">
                        <span class="font-medium"
                        [ngClass]="{
                          'text-gray-900': !isDarkMode(),
                          'text-gray-200': isDarkMode()
                        }">Can edit agents</span>
                      </span>
                    </div>
                </div>

                <div class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">                
                  <div class="flex items-center">
                    <button type="button" (click)="toggleCanUseAdvancedEditor()" [class.bg-emerald-500]="can_use_advanced_editor" [class.bg-gray-200]="!can_use_advanced_editor" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                      [ngClass]="{
                        'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                        'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                      }" role="switch" aria-checked="false" aria-labelledby="can-use-advanced-editor-label">
                      <span aria-hidden="true" [class.translate-x-5]="can_use_advanced_editor" [class.translate-x-0]="!can_use_advanced_editor" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                    </button>
                    <input type="hidden" id="can-use-advanced-editor" name="can-use-advanced-editor" value="false" [(ngModel)]="can_use_advanced_editor">
                    <span class="ml-3 text-sm" id="can-use-advanced-editor-label">
                      <span class="font-medium"
                        [ngClass]="{
                          'text-gray-900': !isDarkMode(),
                          'text-gray-200': isDarkMode()
                        }">Can use advanced editor</span>
                      <span class="text-xs block"
                        [ngClass]="{
                          'text-gray-500': !isDarkMode(),
                          'text-gray-400': isDarkMode()
                        }">Access to full agent configuration</span>
                    </span>
                  </div>
                </div>

                <div *ngIf="currentUserCanAccessCrm" class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">                
                  <div class="flex items-center">
                    <button type="button" (click)="toggleCanAccessCrm()" [class.bg-emerald-500]="can_access_crm" [class.bg-gray-200]="!can_access_crm" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                      [ngClass]="{
                        'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                        'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                      }" role="switch" aria-checked="false" aria-labelledby="can-access-crm-label">
                      <span aria-hidden="true" [class.translate-x-5]="can_access_crm" [class.translate-x-0]="!can_access_crm" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                    </button>
                    <input type="hidden" id="can-access-crm" name="can-access-crm" value="false" [(ngModel)]="can_access_crm">
                    <span class="ml-3 text-sm" id="can-access-crm-label">
                      <span class="font-medium"
                        [ngClass]="{
                          'text-gray-900': !isDarkMode(),
                          'text-gray-200': isDarkMode()
                        }">Can access CRM</span>
                      <span class="text-xs block"
                        [ngClass]="{
                          'text-gray-500': !isDarkMode(),
                          'text-gray-400': isDarkMode()
                        }">Access to customer relationship management</span>
                    </span>
                  </div>
                </div>

                <div *ngIf="currentUserCanAccessCrm" class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">                
                  <div class="flex items-center">
                    <button type="button" (click)="toggleCanViewBillableMinutes()" [class.bg-emerald-500]="can_view_billable_minutes" [class.bg-gray-200]="!can_view_billable_minutes" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                      [ngClass]="{
                        'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                        'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                      }" role="switch" aria-checked="false" aria-labelledby="can-view-billable-minutes-label">
                      <span aria-hidden="true" [class.translate-x-5]="can_view_billable_minutes" [class.translate-x-0]="!can_view_billable_minutes" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                    </button>
                    <input type="hidden" id="can-view-billable-minutes" name="can-view-billable-minutes" value="false" [(ngModel)]="can_view_billable_minutes">
                    <span class="ml-3 text-sm" id="can-view-billable-minutes-label">
                      <span class="font-medium"
                        [ngClass]="{
                          'text-gray-900': !isDarkMode(),
                          'text-gray-200': isDarkMode()
                        }">Can view billable minutes</span>
                      <span class="text-xs block"
                        [ngClass]="{
                          'text-gray-500': !isDarkMode(),
                          'text-gray-400': isDarkMode()
                        }">Access to the billable minutes panel</span>
                    </span>
                  </div>
                </div>

                <div class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">
                  <div class="flex items-center">
                    <button type="button" (click)="toggleCanViewRecordings()" [class.bg-emerald-500]="can_view_recordings" [class.bg-gray-200]="!can_view_recordings" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                      [ngClass]="{
                        'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                        'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                      }" role="switch" aria-checked="false" aria-labelledby="can-view-recordings-label">
                      <span aria-hidden="true" [class.translate-x-5]="can_view_recordings" [class.translate-x-0]="!can_view_recordings" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                    </button>
                    <input type="hidden" id="can-view-recordings" name="can-view-recordings" value="false" [(ngModel)]="can_view_recordings">
                    <span class="ml-3 text-sm" id="annual-billing-label">
                      <span class="font-medium"
                        [ngClass]="{
                          'text-gray-900': !isDarkMode(),
                          'text-gray-200': isDarkMode()
                        }">Can view recordings</span>
                    </span>
                  </div>
                </div>

                <div class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">
                  <div class="flex items-center">
                    <button type="button" (click)="toggleCanManageTokens()" [class.bg-emerald-500]="can_manage_tokens" [class.bg-gray-200]="!can_manage_tokens" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                      [ngClass]="{
                        'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                        'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                      }" role="switch" aria-checked="false" aria-labelledby="can-manage-tokens-label">
                      <span aria-hidden="true" [class.translate-x-5]="can_manage_tokens" [class.translate-x-0]="!can_manage_tokens" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                    </button>
                    <input type="hidden" id="can-manage-tokens" name="can-manage-tokens" value="false" [(ngModel)]="can_manage_tokens">
                    <span class="ml-3 text-sm" id="can-manage-tokens-label">
                      <span class="font-medium"
                        [ngClass]="{
                          'text-gray-900': !isDarkMode(),
                          'text-gray-200': isDarkMode()
                        }">Can manage API tokens</span>
                      <span class="text-xs block"
                        [ngClass]="{
                          'text-gray-500': !isDarkMode(),
                          'text-gray-400': isDarkMode()
                        }">Access to view and create API tokens</span>
                    </span>
                  </div>
                </div>



                  <div class="mb-4">
                    <legend class="mt-10 pb-4 text-base font-semibold flex gap-2"
                      [ngClass]="{
                        'text-gray-900': !isDarkMode(),
                        'text-white': isDarkMode()
                      }">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z" />
                      </svg>
                      Agents the member can view or edit
                    </legend>
                    <div class="isolate -space-y-px rounded max-h-48 overflow-y-auto">
                      <div *ngFor="let playbook of listOfPlaybooks" class="relative flex items-center ring-1 ring-inset py-4 px-4"
                        [ngClass]="{
                          'ring-gray-300': !isDarkMode(),
                          'ring-gray-600': isDarkMode()
                        }">
                        <div class="flex h-4 items-center">
                          <input id="{{playbook.id}}" [(ngModel)]="playbook.selected" (change)="onCheckboxChange(playbook)" aria-describedby="comments-description" name="playbooks" type="checkbox" class="h-4 w-4 rounded"
                          [ngClass]="{
                            'border-gray-300 text-emerald-600 focus:ring-emerald-600 bg-white': !isDarkMode(),
                            'border-gray-600 text-blue-600 focus:ring-blue-500 bg-gray-700': isDarkMode()
                          }">
                        </div>
                        <div class="ml-3 text-sm leading-6">
                          <label for="{{playbook.id}}" class="font-medium text-sm gap-2"
                          [ngClass]="{
                            'text-gray-900': !isDarkMode(),
                            'text-gray-200': isDarkMode()
                          }">{{playbook.name}} <span *ngIf="domain=='meetzy.io'" class="text-xs rounded border px-2 py-1"
                          [ngClass]="{
                            'bg-slate-100 text-gray-900': !isDarkMode(),
                            'bg-gray-600 text-gray-200': isDarkMode()
                          }">{{playbook.company}}</span></label>
                        </div>
                      </div>
                    </div>
                  </div>

                </ng-container>

                </form>

            </div>
          </div>
          
          <!-- Send Email Toggle - positioned just above the button -->
          <div class="mt-4 sm:mt-6">
            <div class="relative rounded-md px-3 py-4 ring-1 ring-inset"
              [ngClass]="{
                'ring-gray-300 bg-white': !isDarkMode(),
                'ring-gray-600 bg-gray-800': isDarkMode()
              }">
              <div class="flex items-center">
                <button type="button" (click)="toggleSendEmail()" [class.bg-emerald-500]="send_email" [class.bg-gray-200]="!send_email" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                  [ngClass]="{
                    'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                    'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                  }" role="switch" aria-checked="false" aria-labelledby="send-email-label">
                  <span aria-hidden="true" [class.translate-x-5]="send_email" [class.translate-x-0]="!send_email" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                </button>
                <input type="hidden" id="send-email" name="send-email" value="false" [(ngModel)]="send_email">
                <span class="ml-3 text-sm" id="send-email-label">
                  <span class="font-medium"
                    [ngClass]="{
                      'text-gray-900': !isDarkMode(),
                      'text-gray-200': isDarkMode()
                    }">Send invitation email</span>
                  <span class="text-xs block"
                    [ngClass]="{
                      'text-gray-500': !isDarkMode(),
                      'text-gray-400': isDarkMode()
                    }">Send an email invitation to the new member</span>
                </span>
              </div>
            </div>
          </div>
          
          <div class="mt-5 sm:mt-6">
            <button type="button" (click)="sendInvite()"
              class="inline-flex w-full justify-center rounded-md bg-emerald-500 px-3 py-3 text-sm font-semibold text-white shadow-sm hover:bg-emerald-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">{{dynamicButtonText}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- MODAL FOR EDIT PLAYBOOKS -->
  <div *ngIf="showEditMemberModal" class="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <!--
    Background backdrop, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
    <div class="fixed inset-0 transition-opacity" aria-hidden="true"
      [ngClass]="{
        'bg-gray-500 bg-opacity-75': !isDarkMode(),
        'bg-gray-900 bg-opacity-80': isDarkMode()
      }"></div>

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
          From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
          From: "opacity-100 translate-y-0 sm:scale-100"
          To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      -->
        <div
          class="relative transform overflow-hidden rounded-lg px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
          [ngClass]="{
            'bg-white': !isDarkMode(),
            'bg-gray-800': isDarkMode()
          }">
          <div (click)="closeEditMemberModal()" class="absolute top-5 right-5 rounded-full cursor-pointer hover:bg-red-400 hover:text-white px-1 py-1 flex justify-center content-center"
            [ngClass]="{
              'bg-slate-100 text-gray-900': !isDarkMode(),
              'bg-gray-600 text-white': isDarkMode()
            }">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

          </div>

          <div>
            <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-8">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
              </svg>

            </div>
            <div class="mt-3 text-left sm:mt-5">
              <h3 class="text-lg font-semibold text-center leading-6" id="modal-title"
                [ngClass]="{
                  'text-gray-900': !isDarkMode(),
                  'text-white': isDarkMode()
                }">Change the member details
              </h3>
              <!--
              This example requires some changes to your config:

              ```
              // tailwind.config.js
              module.exports = {
                // ...
                plugins: [
                  // ...
                  require('@tailwindcss/forms'),
                ],
              }
              ```
            -->
              <form class="isolate -space-y-px rounded-md shadow-sm mt-5">
                <legend class="mt-10 pb-4 text-base font-semibold flex gap-2 text-gray-900 dark:text-white">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.182 15.182a4.5 4.5 0 0 1-6.364 0M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0ZM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75Zm-.375 0h.008v.015h-.008V9.75Z" />
                  </svg>

                  Profile
                </legend>
               
                <div
                  class="relative rounded-none px-3 pb-1.5 pt-2.5 ring-1 ring-inset focus-within:z-10 focus-within:ring-2"
                  [ngClass]="{
                    'ring-gray-300 focus-within:ring-emerald-500': !isDarkMode(),
                    'ring-gray-600 focus-within:ring-blue-500': isDarkMode()
                  }">
                  <label for="name" class="block text-sm font-medium"
                  [ngClass]="{
                    'text-gray-900': !isDarkMode(),
                    'text-gray-200': isDarkMode()
                  }">Email</label>
                  <input type="email" name="email" id="email" disabled
                    class="disabled block w-full border-0 p-0 py-2 bg-transparent focus:ring-0 sm:text-sm sm:leading-6"
                    [ngClass]="{
                      'text-gray-400 placeholder:text-gray-400': !isDarkMode(),
                      'text-gray-500 placeholder:text-gray-500': isDarkMode()
                    }"
                    placeholder="jane@acme.inc" [(ngModel)]="emailEdit">
                  <p class="text-xs mt-1" [ngClass]="{ 'text-gray-400': !isDarkMode(), 'text-gray-500': isDarkMode() }">
                    To change this email, use "Change email" from the member's menu instead.
                  </p>
                </div>

                <div class="relative rounded-none px-3 pb-3 pt-2.5 ring-1 ring-inset border-t-0"
                  [ngClass]="{
                    'ring-gray-300': !isDarkMode(),
                    'ring-gray-600': isDarkMode()
                  }">
                  <span class="block text-sm font-medium mb-1" [ngClass]="{ 'text-gray-900': !isDarkMode(), 'text-gray-200': isDarkMode() }">Role</span>
                  <span class="inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold uppercase tracking-wide"
                    [ngClass]="{
                      'bg-emerald-100 text-emerald-700': roleEdit === 'admin' && !isDarkMode(),
                      'bg-emerald-500/15 text-emerald-400': roleEdit === 'admin' && isDarkMode(),
                      'bg-slate-100 text-slate-500': roleEdit !== 'admin' && !isDarkMode(),
                      'bg-gray-700 text-gray-300': roleEdit !== 'admin' && isDarkMode()
                    }">{{ roleEdit === 'admin' ? 'Admin' : 'Member' }}</span>
                  <span class="text-xs ml-2" [ngClass]="{ 'text-gray-400': !isDarkMode(), 'text-gray-500': isDarkMode() }">
                    Use "Promote to admin" / "Demote to member" from the menu to change this.
                  </span>
                </div>

                <div class="flex ">
                  <div
                    class="relative px-3 pb-1.5 pt-2.5 border-r border-l ring-inset focus-within:z-10 focus-within:ring-2"
                    [ngClass]="{
                      'border-gray-300 ring-gray-300 focus-within:ring-emerald-500': !isDarkMode(),
                      'border-gray-600 ring-gray-600 focus-within:ring-blue-500': isDarkMode()
                    }">
                    <label for="name" class="block text-sm font-medium"
                  [ngClass]="{
                    'text-gray-900': !isDarkMode(),
                    'text-gray-200': isDarkMode()
                  }">Name <span class="text-xs"
                      [ngClass]="{
                        'text-slate-400': !isDarkMode(),
                        'text-gray-500': isDarkMode()
                      }">(required)</span></label>
                    <input type="text" name="fullname" id="fullname"
                      class="block w-full border-0 p-0 py-2 bg-transparent focus:ring-0 sm:text-sm sm:leading-6"
                      [ngClass]="{
                        'text-gray-900 placeholder:text-gray-400': !isDarkMode(),
                        'text-white placeholder:text-gray-500': isDarkMode()
                      }"
                      placeholder="Jane Smith" [(ngModel)]="nameEdit">
                  </div>
                  <div
                    class="relative rounded-md rounded-t-none px-3 pb-1.5 pt-2.5 border-r ring-inset focus-within:z-10 focus-within:ring-2"
                    [ngClass]="{
                      'border-gray-300 ring-gray-300 focus-within:ring-emerald-500': !isDarkMode(),
                      'border-gray-600 ring-gray-600 focus-within:ring-blue-500': isDarkMode()
                    }">
                    <label for="job-title" class="block text-sm font-medium"
                  [ngClass]="{
                    'text-gray-900': !isDarkMode(),
                    'text-gray-200': isDarkMode()
                  }">Job Title</label>
                    <input type="text" name="job-title" id="job-title"
                      class="block w-full border-0 p-0 py-2 bg-transparent focus:ring-0 sm:text-sm sm:leading-6"
                      [ngClass]="{
                        'text-gray-900 placeholder:text-gray-400': !isDarkMode(),
                        'text-white placeholder:text-gray-500': isDarkMode()
                      }"
                      placeholder="Head of ..." [(ngModel)]="job_titleEdit">
                  </div>
                </div>

                <ng-container *ngIf="roleEdit === 'member'">

                <div
                  class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">
                    <div class="flex items-center">
                      <!-- Enabled: "bg-indigo-600", Not Enabled: "bg-gray-200" -->
                      <button type="button" (click)="toggleCanEditEdit()" [class.bg-emerald-500]="can_editEdit" [class.bg-gray-200]="!can_editEdit"  class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                        [ngClass]="{
                          'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                          'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                        }" role="switch" aria-checked="false" aria-labelledby="can-edit-label">
                        <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
                        <span aria-hidden="true" [class.translate-x-5]="can_editEdit" [class.translate-x-0]="!can_editEdit" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                      </button>
                      <input type="hidden" id="can-edit-edit" name="can-edit-edit" value="false" [(ngModel)]="can_editEdit">
                      <span class="ml-3 text-sm" id="annual-billing-label">
                        <span class="font-medium"
                          [ngClass]="{
                            'text-gray-900': !isDarkMode(),
                            'text-gray-200': isDarkMode()
                          }">Can edit agents</span>
                      </span>
                    </div>
                </div>

                <div class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">                
                  <div class="flex items-center">
                    <button type="button" (click)="toggleCanUseAdvancedEditorEdit()" [class.bg-emerald-500]="can_use_advanced_editorEdit" [class.bg-gray-200]="!can_use_advanced_editorEdit" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                      [ngClass]="{
                        'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                        'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                      }" role="switch" aria-checked="false" aria-labelledby="can-use-advanced-editor-edit-label">
                      <span aria-hidden="true" [class.translate-x-5]="can_use_advanced_editorEdit" [class.translate-x-0]="!can_use_advanced_editorEdit" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                    </button>
                    <input type="hidden" id="can-use-advanced-editor-edit" name="can-use-advanced-editor-edit" value="false" [(ngModel)]="can_use_advanced_editorEdit">
                    <span class="ml-3 text-sm" id="can-use-advanced-editor-edit-label">
                      <span class="font-medium"
                        [ngClass]="{
                          'text-gray-900': !isDarkMode(),
                          'text-gray-200': isDarkMode()
                        }">Can use advanced editor</span>
                      <span class="text-xs block"
                        [ngClass]="{
                          'text-gray-500': !isDarkMode(),
                          'text-gray-400': isDarkMode()
                        }">Access to full agent configuration</span>
                    </span>
                  </div>
                </div>

                <div *ngIf="currentUserCanAccessCrm" class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">                
                  <div class="flex items-center">
                    <button type="button" (click)="toggleCanAccessCrmEdit()" [class.bg-emerald-500]="can_access_crmEdit" [class.bg-gray-200]="!can_access_crmEdit" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                      [ngClass]="{
                        'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                        'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                      }" role="switch" aria-checked="false" aria-labelledby="can-access-crm-edit-label">
                      <span aria-hidden="true" [class.translate-x-5]="can_access_crmEdit" [class.translate-x-0]="!can_access_crmEdit" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                    </button>
                    <input type="hidden" id="can-access-crm-edit" name="can-access-crm-edit" value="false" [(ngModel)]="can_access_crmEdit">
                    <span class="ml-3 text-sm" id="can-access-crm-edit-label">
                      <span class="font-medium"
                        [ngClass]="{
                          'text-gray-900': !isDarkMode(),
                          'text-gray-200': isDarkMode()
                        }">Can access CRM</span>
                      <span class="text-xs block"
                        [ngClass]="{
                          'text-gray-500': !isDarkMode(),
                          'text-gray-400': isDarkMode()
                        }">Access to customer relationship management</span>
                    </span>
                  </div>
                </div>

                <div *ngIf="currentUserCanAccessCrm" class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">                
                  <div class="flex items-center">
                    <button type="button" (click)="toggleCanViewBillableMinutesEdit()" [class.bg-emerald-500]="can_view_billable_minutesEdit" [class.bg-gray-200]="!can_view_billable_minutesEdit" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                      [ngClass]="{
                        'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                        'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                      }" role="switch" aria-checked="false" aria-labelledby="can-view-billable-minutes-edit-label">
                      <span aria-hidden="true" [class.translate-x-5]="can_view_billable_minutesEdit" [class.translate-x-0]="!can_view_billable_minutesEdit" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                    </button>
                    <input type="hidden" id="can-view-billable-minutes-edit" name="can-view-billable-minutes-edit" value="false" [(ngModel)]="can_view_billable_minutesEdit">
                    <span class="ml-3 text-sm" id="can-view-billable-minutes-edit-label">
                      <span class="font-medium"
                        [ngClass]="{
                          'text-gray-900': !isDarkMode(),
                          'text-gray-200': isDarkMode()
                        }">Can view billable minutes</span>
                      <span class="text-xs block"
                        [ngClass]="{
                          'text-gray-500': !isDarkMode(),
                          'text-gray-400': isDarkMode()
                        }">Access to the billable minutes panel</span>
                    </span>
                  </div>
                </div>

                <div class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">
                  <div class="flex items-center">
                    <button type="button" (click)="toggleCanViewRecordings()" [class.bg-emerald-500]="can_view_recordings" [class.bg-gray-200]="!can_view_recordings" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                      [ngClass]="{
                        'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                        'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                      }" role="switch" aria-checked="false" aria-labelledby="can-view-recordings-label">
                      <span aria-hidden="true" [class.translate-x-5]="can_view_recordings" [class.translate-x-0]="!can_view_recordings" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                    </button>
                    <input type="hidden" id="can-view-recordings" name="can-view-recordings" value="false" [(ngModel)]="can_view_recordings">
                    <span class="ml-3 text-sm" id="annual-billing-label">
                      <span class="font-medium"
                        [ngClass]="{
                          'text-gray-900': !isDarkMode(),
                          'text-gray-200': isDarkMode()
                        }">Can view recordings</span>
                    </span>
                  </div>
                </div>

                <div class="relative rounded-md rounded-t-none px-3 pb-4 pt-4 ring-1 ring-inset"
                  [ngClass]="{
                    'ring-gray-300 bg-white': !isDarkMode(),
                    'ring-gray-600 bg-gray-800': isDarkMode()
                  }">
                  <div class="flex items-center">
                    <button type="button" (click)="toggleCanManageTokensEdit()" [class.bg-emerald-500]="can_manage_tokensEdit" [class.bg-gray-200]="!can_manage_tokensEdit" class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2"
                      [ngClass]="{
                        'bg-gray-200 focus:ring-emerald-600 focus:ring-offset-white': !isDarkMode(),
                        'bg-gray-600 focus:ring-blue-500 focus:ring-offset-gray-800': isDarkMode()
                      }" role="switch" aria-checked="false" aria-labelledby="can-manage-tokens-edit-label">
                      <span aria-hidden="true" [class.translate-x-5]="can_manage_tokensEdit" [class.translate-x-0]="!can_manage_tokensEdit" class="pointer-events-none inline-block h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                    </button>
                    <input type="hidden" id="can-manage-tokens-edit" name="can-manage-tokens-edit" value="false" [(ngModel)]="can_manage_tokensEdit">
                    <span class="ml-3 text-sm" id="can-manage-tokens-edit-label">
                      <span class="font-medium"
                        [ngClass]="{
                          'text-gray-900': !isDarkMode(),
                          'text-gray-200': isDarkMode()
                        }">Can manage API tokens</span>
                      <span class="text-xs block"
                        [ngClass]="{
                          'text-gray-500': !isDarkMode(),
                          'text-gray-400': isDarkMode()
                        }">Access to view and create API tokens</span>
                    </span>
                  </div>
                </div>

                  <div class="mb-4">
                    <legend class="mt-10 pb-4 text-base font-semibold flex gap-2"
                      [ngClass]="{
                        'text-gray-900': !isDarkMode(),
                        'text-white': isDarkMode()
                      }">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z" />
                      </svg>
                      Agents the user can view
                    </legend>
                    <div class="isolate -space-y-px rounded max-h-48 overflow-y-auto">
                      <div *ngFor="let playbook of listOfPlaybooks" class="relative flex items-center ring-1 ring-inset py-4 px-4"
                        [ngClass]="{
                          'ring-gray-300': !isDarkMode(),
                          'ring-gray-600': isDarkMode()
                        }">
                        <div class="flex h-4 items-center">
                          <input id="{{playbook.id}}" *ngIf="isPlaybookIncluded(playbook.id)"  (change)="onCheckboxChange(playbook)" aria-describedby="comments-description" name="playbooksEdit" type="checkbox" class="h-4 w-4 rounded"
                          [ngClass]="{
                            'border-gray-300 text-emerald-600 focus:ring-emerald-600 bg-white': !isDarkMode(),
                            'border-gray-600 text-blue-600 focus:ring-blue-500 bg-gray-700': isDarkMode()
                          }" checked>
                          <input id="{{playbook.id}}" *ngIf="!isPlaybookIncluded(playbook.id)"  (change)="onCheckboxChange(playbook)" aria-describedby="comments-description" name="playbooksEdit" type="checkbox" class="h-4 w-4 rounded"
                          [ngClass]="{
                            'border-gray-300 text-emerald-600 focus:ring-emerald-600 bg-white': !isDarkMode(),
                            'border-gray-600 text-blue-600 focus:ring-blue-500 bg-gray-700': isDarkMode()
                          }" >
                        </div>
                        <div class="ml-3 text-sm leading-6">
                          <label for="{{playbook.id}}" class="font-medium text-sm"
                          [ngClass]="{
                            'text-gray-900': !isDarkMode(),
                            'text-gray-200': isDarkMode()
                          }">{{playbook.name}} <span *ngIf="domain=='meetzy.io'" class="text-xs rounded border px-2 py-1"
                          [ngClass]="{
                            'bg-slate-100 text-gray-900': !isDarkMode(),
                            'bg-gray-600 text-gray-200': isDarkMode()
                          }">{{playbook.company}}</span></label>
                        </div>
                      </div>
                    </div>
                  </div>

                </ng-container>

                </form>

            </div>
          </div>
          <div class="mt-5 sm:mt-6">
            <button type="button" (click)="updateMember()"
              class="inline-flex w-full justify-center rounded-md bg-emerald-500 px-3 py-3 text-sm font-semibold text-white shadow-sm hover:bg-emerald-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">{{txtUpdateMember}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- MODAL REMOVE MEMBER -->
  <div *ngIf="shownotificationForRemove" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <!--
      Background backdrop, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="fixed inset-0 transition-opacity" aria-hidden="true"
      [ngClass]="{
        'bg-gray-500 bg-opacity-75': !isDarkMode(),
        'bg-gray-900 bg-opacity-80': isDarkMode()
      }"></div>

    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <!--
          Modal panel, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
        <div class="relative transform overflow-hidden rounded-lg bg-white dark:bg-gray-800 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
          <div class="px-4 pb-4 pt-5 sm:p-6 sm:pb-4"
            [ngClass]="{
              'bg-white': !isDarkMode(),
              'bg-gray-800': isDarkMode()
            }">
            <div class="sm:flex sm:items-start">
              <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10"
                [ngClass]="{
                  'bg-red-100': !isDarkMode(),
                  'bg-red-900/20': isDarkMode()
                }">
                <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true"
                  [ngClass]="{
                    'text-red-600': !isDarkMode(),
                    'text-red-400': isDarkMode()
                  }">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M22 10.5h-6m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
                </svg>
              </div>
              <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <h3 class="text-base font-semibold leading-6" id="modal-title"
                  [ngClass]="{
                    'text-gray-900': !isDarkMode(),
                    'text-white': isDarkMode()
                  }">Remove {{this.txtMemberNameToRemove}} from your team?</h3>
                <div class="mt-2">
                  <p class="text-sm"
                    [ngClass]="{
                      'text-gray-500': !isDarkMode(),
                      'text-gray-400': isDarkMode()
                    }">{{this.txtMemberNameToRemove}} will lose access to this account. Your calls, agents, contacts and the rest of your account's data stay exactly as they are.</p>
                  <p class="mt-2 text-sm"
                    [ngClass]="{
                      'text-gray-500': !isDarkMode(),
                      'text-gray-400': isDarkMode()
                    }">If they need access again, you can invite them back at any time.</p>

                  <!-- Sus rutinas personales: qué hacer con cada una antes de quitarle -->
                  <p *ngIf="removeRoutinesLoading" class="mt-3 text-sm"
                    [ngClass]="{ 'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode() }">Checking their routines…</p>

                  <p *ngIf="removeRoutinesUnknown" class="mt-3 rounded-md px-3 py-2 text-sm"
                    [ngClass]="{ 'bg-amber-50 text-amber-800': !isDarkMode(), 'bg-amber-900/20 text-amber-300': isDarkMode() }">
                    We couldn't check their routines. If they have any personal routines, they'll move to the account, paused.
                  </p>

                  <div *ngIf="removeRoutines && removeRoutines.owned.length > 0" class="mt-4">
                    <p class="text-sm font-medium"
                      [ngClass]="{ 'text-gray-900': !isDarkMode(), 'text-white': isDarkMode() }">
                      {{ txtMemberNameToRemove }} has {{ removeRoutines.owned.length }} personal routine{{ removeRoutines.owned.length === 1 ? '' : 's' }}. What should happen to {{ removeRoutines.owned.length === 1 ? 'it' : 'them' }}?
                    </p>
                    <ul class="mt-2 space-y-2">
                      <li *ngFor="let routine of removeRoutines.owned" class="rounded-md border px-3 py-2"
                        [ngClass]="{ 'border-gray-200': !isDarkMode(), 'border-gray-600': isDarkMode() }">
                        <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                          <div class="min-w-0">
                            <p class="truncate text-sm font-medium"
                              [ngClass]="{ 'text-gray-900': !isDarkMode(), 'text-white': isDarkMode() }">{{ routine.name || 'Untitled routine' }}</p>
                            <p class="text-xs"
                              [ngClass]="{ 'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode() }">{{ describeRoutineSchedule(routine.schedule_preset) }}{{ routine.enabled ? '' : ' · paused' }}</p>
                          </div>
                          <select [(ngModel)]="removeRoutineChoices[routine.id]" [attr.aria-label]="'What to do with ' + (routine.name || 'this routine')"
                            class="rounded-md border px-2 py-1 text-sm"
                            [ngClass]="{ 'border-gray-300 bg-white text-gray-900': !isDarkMode(), 'border-gray-600 bg-gray-700 text-white': isDarkMode() }">
                            <option value="account">Move to the account</option>
                            <option *ngFor="let ws of removeWorkspaces" [value]="'ws:' + ws.id">Move to {{ ws.name }}</option>
                            <option value="delete">Delete it</option>
                          </select>
                        </div>
                      </li>
                    </ul>
                    <p class="mt-2 text-xs"
                      [ngClass]="{ 'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode() }">
                      Moved routines arrive paused and send to the account owner until an admin turns them back on. From then on they run with the access of the account or workspace, not {{ txtMemberNameToRemove }}'s.
                    </p>
                  </div>

                  <p *ngIf="removeRoutines && removeRoutines.editing.length > 0" class="mt-3 text-xs"
                    [ngClass]="{ 'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode() }">
                    They'll also stop editing: {{ routineNames(removeRoutines.editing) }}.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6"
            [ngClass]="{
              'bg-gray-50': !isDarkMode(),
              'bg-gray-700': isDarkMode()
            }">
            <button type="button" (click)="deleteMember(memberForRemove?.id)" [disabled]="removeRoutinesLoading" class="inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm disabled:opacity-50 sm:ml-3 sm:w-auto"
              [ngClass]="{
                'bg-red-500 hover:bg-red-500': !isDarkMode(),
                'bg-red-600 hover:bg-red-700': isDarkMode()
              }">Remove from team</button>
            <button type="button" (click)="hideNotificationForRemove()" class="mt-3 inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm ring-1 ring-inset sm:mt-0 sm:w-auto"
              [ngClass]="{
                'bg-white text-gray-900 ring-gray-300 hover:bg-gray-50': !isDarkMode(),
                'bg-gray-700 text-gray-300 ring-gray-600 hover:bg-gray-600': isDarkMode()
              }">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>

<!-- Change Password Modal -->
<div *ngIf="showChangePasswordModal" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 transition-opacity" aria-hidden="true"
    [ngClass]="{
      'bg-gray-500 bg-opacity-75': !isDarkMode(),
      'bg-gray-900 bg-opacity-80': isDarkMode()
    }"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6" 
        [ngClass]="{
          'bg-white': !isDarkMode(),
          'bg-gray-800': isDarkMode()
        }">
        <div>
          <div (click)="closeChangePasswordModal()" class="absolute top-5 right-5 rounded-full cursor-pointer px-1 py-1 flex justify-center content-center transition-colors" 
            [ngClass]="{
              'hover:bg-red-400 hover:text-white bg-slate-100 text-gray-900': !isDarkMode(),
              'hover:bg-red-600 hover:text-white bg-gray-700 text-gray-300': isDarkMode()
            }">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </div>

          <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
            </svg>
          </div>

          <div class="mt-3 text-center sm:mt-5">
            <h3 class="text-lg font-semibold leading-6" 
              [ngClass]="{
                'text-gray-900': !isDarkMode(),
                'text-gray-100': isDarkMode()
              }">
              Change Password
            </h3>

            <div class="mt-4">
              <p class="text-sm" 
                [ngClass]="{
                  'text-gray-500': !isDarkMode(),
                  'text-gray-400': isDarkMode()
                }">
                Change password for {{selectedMember?.name}} ({{selectedMember?.email}})
              </p>

              <div class="mt-4">
                <input type="password" 
                       [(ngModel)]="newPassword"
                       placeholder="New password"
                       class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6" 
                       [ngClass]="{
                         'text-gray-900 ring-gray-300': !isDarkMode(),
                         'text-gray-100 bg-gray-700 ring-gray-600': isDarkMode()
                       }">
                
                <p *ngIf="showPasswordError" class="mt-2 text-sm text-red-600">
                  {{passwordErrorMessage}}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-5 sm:mt-6">
          <button type="button"
                  (click)="updateMemberPassword()"
                  class="inline-flex w-full justify-center rounded-md bg-emerald-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-emerald-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600">
            Update Password
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Change Email Modal -->
<div *ngIf="showChangeEmailModal" class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="fixed inset-0 transition-opacity" aria-hidden="true"
    [ngClass]="{
      'bg-gray-500 bg-opacity-75': !isDarkMode(),
      'bg-gray-900 bg-opacity-80': isDarkMode()
    }"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6"
        [ngClass]="{
          'bg-white': !isDarkMode(),
          'bg-gray-800': isDarkMode()
        }">
        <div (click)="closeChangeEmailModal()" class="absolute top-5 right-5 rounded-full cursor-pointer px-1 py-1 flex justify-center content-center transition-colors"
          [ngClass]="{
            'hover:bg-red-400 hover:text-white bg-slate-100 text-gray-900': !isDarkMode(),
            'hover:bg-red-600 hover:text-white bg-gray-700 text-gray-300': isDarkMode()
          }">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
          </svg>
        </div>

        <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
          </svg>
        </div>

        <div class="mt-3 text-center sm:mt-5">
          <h3 class="text-lg font-semibold leading-6"
            [ngClass]="{ 'text-gray-900': !isDarkMode(), 'text-gray-100': isDarkMode() }">
            Change email
          </h3>

          <div class="mt-4 text-left">
            <p class="text-sm" [ngClass]="{ 'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode() }">
              {{memberForEmailChange?.name}} currently signs in with <strong>{{memberForEmailChange?.email}}</strong>.
            </p>

            <label class="block text-sm font-medium mt-4 mb-1" [ngClass]="{ 'text-gray-900': !isDarkMode(), 'text-gray-200': isDarkMode() }">New email</label>
            <input type="email"
                   [(ngModel)]="newMemberEmail"
                   placeholder="new-email@company.com"
                   class="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6"
                   [ngClass]="{
                     'text-gray-900 ring-gray-300': !isDarkMode(),
                     'text-gray-100 bg-gray-700 ring-gray-600': isDarkMode()
                   }">

            <p class="mt-2 text-xs" [ngClass]="{ 'text-gray-500': !isDarkMode(), 'text-gray-400': isDarkMode() }">
              They'll get an email at the new address to confirm it, then need to sign in again.
            </p>

            <p *ngIf="emailChangeError" class="mt-2 text-sm text-red-600">{{emailChangeError}}</p>
          </div>
        </div>

        <div class="mt-5 sm:mt-6">
          <button type="button"
                  (click)="submitChangeEmail()"
                  [disabled]="emailChangeSaving"
                  class="inline-flex w-full justify-center rounded-md bg-emerald-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-emerald-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600 disabled:opacity-60">
            {{ emailChangeSaving ? 'Saving...' : 'Update email' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- NOTIFICATION SUCCESS -->
<div id="notificationSuccess" *ngIf="shownotificationSuccess" aria-live="assertive" class="z-10 pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-end">
  <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
    <!--
      Notification panel, dynamically insert this into the live region when it needs to be displayed

      Entering: "transform ease-out duration-300 transition"
        From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        To: "translate-y-0 opacity-100 sm:translate-x-0"
      Leaving: "transition ease-in duration-100"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black dark:ring-gray-700 ring-opacity-5 dark:ring-opacity-50">
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <svg class="h-6 w-6 text-green-400 dark:text-green-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium text-gray-900 dark:text-white">{{this.txtNotificationSuccessTitle}}</p>
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{this.txtNotificationSuccessMessage}}</p>
          </div>
          <div class="ml-4 flex flex-shrink-0">
            <button type="button" (click)="hideNotificationMemberUpdated()" class="inline-flex rounded-md bg-white dark:bg-gray-800 text-gray-400 dark:text-gray-500 hover:text-gray-500 dark:hover:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800">
              <span class="sr-only">Close</span>
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- NOTIFICATION ERROR -->
<div id="notificationError" *ngIf="shownotificationError" aria-live="assertive" class="z-10 pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-end sm:p-6">
  <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
    <!--
      Notification panel, dynamically insert this into the live region when it needs to be displayed

      Entering: "transform ease-out duration-300 transition"
        From: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        To: "translate-y-0 opacity-100 sm:translate-x-0"
      Leaving: "transition ease-in duration-100"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black dark:ring-gray-700 ring-opacity-5 dark:ring-opacity-50">
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 text-red-400 dark:text-red-500">
              <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>

          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="text-sm font-medium text-red-600 dark:text-red-400">{{txtNotificationErrorTitle}}</p>
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{txtNotificationErrorMessage}} </p>
          </div>
          <div class="ml-4 flex flex-shrink-0">
            <button type="button" (click)="hideNotificationError()" class="inline-flex rounded-md bg-white dark:bg-gray-800 text-gray-400 dark:text-gray-500 hover:text-gray-500 dark:hover:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800">
              <span class="sr-only">Close</span>
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


